import { Box, Heading } from '@chakra-ui/react';
import ImageShimmer from '../../ImageShimmer/ImageShimmer';
import { Text } from '@terminal/design-system';

export default function Resources({
  categoryTitle,
  imageUrl,
  altText,
  cardTitle,
  size,
  imageIsHighPriority = false,
}: {
  categoryTitle: string;
  imageUrl: string;
  altText: string;
  cardTitle: string;
  size?: string;
  imageIsHighPriority?: boolean;
}) {
  return (
    <Box as="article" aria-labelledby={cardTitle}>
      <Text
        variant="hint"
        fontWeight="bold"
        color="text.secondary"
        textTransform="uppercase"
        letterSpacing="0.0625rem"
      >
        {categoryTitle}
      </Text>
      <Box
        as="figure"
        w="100%"
        h={{
          base: '10.625rem',
          sm: '15.5rem',
          lg: size === 'medium' ? '10rem' : '12.5rem',
          xl: size === 'large' ? '15.5rem' : size === 'medium' ? '12rem' : '10rem',
        }}
        mt="0.5rem"
        position="relative"
      >
        <ImageShimmer
          src={imageUrl}
          alt={altText}
          style={{ objectFit: 'cover' }}
          fill
          priority={imageIsHighPriority}
          sizes="(max-width: 575px) 295px, (max-width: 763px) 430px, (max-width: 991px) 260px, 430px"
        />
      </Box>
      <Heading
        as="h2"
        variant="heading-2"
        fontSize={{
          base: '1.125rem',
          md: size === 'large' ? '1.625rem' : '1.25rem',
        }}
        fontWeight="600"
        lineHeight={{
          base: '1.3125rem',
          md: size === 'large' ? '1.875rem' : '1.5rem',
        }}
        mt={{
          base: '1.0625rem',
          xl: size === 'large' ? '1.5rem' : '1rem',
        }}
        color="#2D445D"
        _groupHover={{ textDecoration: 'underline' }}
      >
        {cardTitle}
      </Heading>
    </Box>
  );
}
